<script setup lang="ts">
import { onMounted, watch } from "vue";
import { usePrimeVue } from "primevue/config";
import { useUIStore } from "@/stores/ui";
import { useAuthStore } from "@/stores/auth";
import { primeLocaleMessages } from "@/plugins/prime-locale";
import Toast from "primevue/toast";
import ConfirmDialog from "primevue/confirmdialog";

const ui = useUIStore();
const auth = useAuthStore();
const primevue = usePrimeVue();

// Mantém o locale do PrimeVue (DatePicker, menus, paginador) em sincronia com
// o idioma escolhido na UI. Substituir config.locale (objeto reativo do próprio
// PrimeVue) propaga para todos os componentes sem recarregar a página. O locale
// inicial já é setado no install (plugins/primevue.ts).
watch(
  () => ui.locale,
  (loc) => {
    primevue.config.locale = primeLocaleMessages(loc);
  },
);

onMounted(async () => {
  // Apply persisted locale to the lang attribute.
  document.documentElement.lang = ui.locale;
  // Pre-warm auth state so guards don't have to wait on first navigation.
  await auth.hydrate();
});
</script>

<template>
  <RouterView />
  <Toast position="top-right" />
  <ConfirmDialog />
</template>
